var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"sf-mega-menu-column"},[_vm._t("title",[_c('h3',{staticClass:"sf-mega-menu-column__title"},[_vm._v(_vm._s(_vm.title))])],null,{ title: _vm.title }),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }